import React from 'react'
import { Box, Flex, Text, Heading } from 'theme-ui'
import { useResource } from '..'
import { useMediaQuery } from 'react-responsive'
import LongArrowRight from '../../../assets/long-arrow-right.svg'

export const CardRows = ({ cards, config }) => {
  let limit = 5

  const { active, setActive } = useResource()

  const xlarge = useMediaQuery({
    query: '(max-device-width: 1300px)',
  })

  const large = useMediaQuery({
    query: '(max-device-width: 992px)',
  })

  const medium = useMediaQuery({
    query: '(max-device-width: 768px)',
  })

  const sml = useMediaQuery({
    query: '(max-device-width: 576px)',
  })

  if (xlarge) limit = 3
  if (large) limit = 3
  if (medium) limit = 2
  if (sml) limit = 1

  return (
    <Box
      sx={{
        mx: [0, 3],
        mt: [4],
      }}
    >
      <Box
        sx={{
          mb: [3],
        }}
      >
        <Flex>
          <Heading>{config.header}</Heading>
          {active !== config.key && (
            <Flex
              sx={{
                ml: 'auto',
                cursor: 'pointer',
              }}
              onClick={() => setActive(config.key)}
            >
              <Text
                sx={{
                  mr: '10px',

                  fontFamily: 'Futura Heavy',
                }}
              >
                View All
              </Text>
              <LongArrowRight width={24} height={20} />
            </Flex>
          )}
        </Flex>
        <Text
          sx={{
            fontFamily: 'Futura Book Regular',
            color: 'grey',
          }}
        >
          {config.body}
        </Text>
      </Box>
      {cards.length > 0 && (
        <Flex
          sx={{
            flexDirection: ['column', 'row'],
            flexWrap: 'wrap',
          }}
        >
          {/* get first 5 or all */}
          {active === 'resources' ? cards.slice(0, limit) : cards}
        </Flex>
      )}
    </Box>
  )
}
